<template>
  <user-list :is-modal="isModal">
    <h2 slot="header">{{ getTranslations.home_users_search_user_find_a_player }}</h2>
    <template slot="content">
      <div :class="['find_player', { 'modal_find_player' : isModal }]">
        <form action="" role="search" class="search">
          <input type="text"
                 class="search-input"
                 @input="search()"
                 @click.prevent=""
                 v-model="username"
                 :placeholder="getTranslations.home_users_search_users_placeholder"
                 aria-label="Search">
          <button type="button" class="search-button"><span>Search</span></button>
        </form>
      </div>
      <span class="fb_error_msg" v-if="userNotFound()">{{ getTranslations.home_users_search_user_user_not_found }}</span>
      <virtual-list v-if="username"
                    :data-key="'username'"
                    :items="getProps()"
                    :wrapperType="'favorite_user'"
                    :remain="5"
                    :estimated="120"/>
    </template>
  </user-list>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import UserList from '@/components/home/shared/GenericList';
import FavoriteUser from '@/components/home/users/FavoriteUser';
import VirtualList from '@/components/home/shared/VirtualScrollList';

export default {
  name: 'search-user',
  props: {
    isModal: Boolean,
  },
  components: {
    UserList,
    FavoriteUser,
    VirtualList,
  },
  data() {
    return {
      username: '',
    };
  },
  created() {
    this.clearSearchedUsers();
  },
  methods: {
    ...mapMutations('users', [
      'clearSearchedUsers',
    ]),
    ...mapActions('users', [
      'searchUsers',
    ]),
    getProps() {
      return this.getSearchedUsers
        .map(user => ({ ...user, isFavorite: this.isFavorite(user.username), isSearchResult: true }));
    },
    userNotFound() {
      return this.username && this.hasErrorResult;
    },
    search() {
      this.searchUsers({ username: this.username });
    },
    isFavorite(username) {
      return this.getFavoriteUsers.filter(user => user.username === username).length !== 0;
    },
  },
  computed: {
    ...mapGetters('users', [
      'getSearchedUsers',
    ]),
    ...mapGetters('users', [
      'getFavoriteUsers',
      'hasErrorResult',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/users/SearchUser.vue